import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskGettingStartedQueueEditRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-queue-edit',
	path: '/jira/servicedesk/projects/:projectKey/getting-started/queues/custom/:queueId/edit/:boardId?',
	query: ['config?'],
	exact: true,
};
